// Danh sách các sản phẩm
export const productsData = [
  // THIẾT BỊ HVAC (20 SP)
  {
    id: 1,
    name: "Chiller giải nhiệt nước Daikin 500RT",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/1/300/300",
  },
  {
    id: 2,
    name: "Điều hòa trung tâm VRV IV Daikin",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/2/300/300",
  },
  {
    id: 3,
    name: "Máy lạnh áp trần Daikin 5.0 HP",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/3/300/300",
  },
  {
    id: 4,
    name: "Dàn nóng điều hòa Multi Daikin",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/4/300/300",
  },
  {
    id: 5,
    name: "FCU đặt sàn Daikin",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/5/300/300",
  },
  {
    id: 6,
    name: "AHU xử lý không khí trung tâm",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/6/300/300",
  },
  {
    id: 7,
    name: "Máy lạnh tủ đứng công nghiệp",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/7/300/300",
  },
  {
    id: 8,
    name: "Hệ thống thông gió thu hồi nhiệt VAM",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/8/300/300",
  },
  {
    id: 9,
    name: "Dàn lạnh âm trần nối ống gió",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/9/300/300",
  },
  {
    id: 10,
    name: "Bộ điều khiển trung tâm Daikin",
    category: "Thiết bị HVAC",
    brand: "Daikin",
    image: "https://picsum.photos/seed/10/300/300",
  },
  {
    id: 11,
    name: "Tháp giải nhiệt Liang Chi",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/11/300/300",
  },
  {
    id: 12,
    name: "Máy nén trục vít Bitzer",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/12/300/300",
  },
  {
    id: 13,
    name: "Quạt thông gió gắn tường Panasonic",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/13/300/300",
  },
  {
    id: 14,
    name: "Máy hút ẩm công nghiệp Harison",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/14/300/300",
  },
  {
    id: 15,
    name: "Kho lạnh bảo quản thực phẩm",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/15/300/300",
  },
  {
    id: 16,
    name: "Ống đồng máy lạnh Toàn Phát",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/16/300/300",
  },
  {
    id: 17,
    name: "Bảo ôn cách nhiệt Superlon",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/17/300/300",
  },
  {
    id: 18,
    name: "Gas lạnh R410A Honeywell",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/18/300/300",
  },
  {
    id: 19,
    name: "Cửa gió nan bầu dục",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/19/300/300",
  },
  {
    id: 20,
    name: "V miệng gió khuyếch tán",
    category: "Thiết bị HVAC",
    brand: "Khác",
    image: "https://picsum.photos/seed/20/300/300",
  },

  // THIẾT BỊ ĐIỆN (20 SP)
  {
    id: 21,
    name: "Máy cắt không khí ACB Schneider",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/21/300/300",
  },
  {
    id: 22,
    name: "Aptomat khối MCCB Schneider",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/22/300/300",
  },
  {
    id: 23,
    name: "Biến tần Altivar Schneider",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/23/300/300",
  },
  {
    id: 24,
    name: "Contactor khởi động từ Schneider",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/24/300/300",
  },
  {
    id: 25,
    name: "Tủ điện nhựa âm tường Schneider",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/25/300/300",
  },
  {
    id: 26,
    name: "Công tắc ổ cắm AvatarOn Schneider",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/26/300/300",
  },
  {
    id: 27,
    name: "Bộ lưu điện UPS APC Schneider",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/27/300/300",
  },
  {
    id: 28,
    name: "Relay nhiệt bảo vệ động cơ",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/28/300/300",
  },
  {
    id: 29,
    name: "Tụ bù hạ thế Schneider",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/29/300/300",
  },
  {
    id: 30,
    name: "Đèn báo nút nhấn công nghiệp",
    category: "Thiết bị Điện",
    brand: "Schneider",
    image: "https://picsum.photos/seed/30/300/300",
  },
  {
    id: 31,
    name: "Máy phát điện Cummins 100kVA",
    category: "Thiết bị Điện",
    brand: "Cummins",
    image: "https://picsum.photos/seed/31/300/300",
  },
  {
    id: 32,
    name: "Máy phát điện Cummins 250kVA",
    category: "Thiết bị Điện",
    brand: "Cummins",
    image: "https://picsum.photos/seed/32/300/300",
  },
  {
    id: 33,
    name: "Máy phát điện Cummins 500kVA",
    category: "Thiết bị Điện",
    brand: "Cummins",
    image: "https://picsum.photos/seed/33/300/300",
  },
  {
    id: 34,
    name: "Đầu phát điện Stamford",
    category: "Thiết bị Điện",
    brand: "Cummins",
    image: "https://picsum.photos/seed/34/300/300",
  },
  {
    id: 35,
    name: "Bảng điều khiển sâu Cummins",
    category: "Thiết bị Điện",
    brand: "Cummins",
    image: "https://picsum.photos/seed/35/300/300",
  },
  {
    id: 36,
    name: "Cáp điện lực hạ thế Cadivi",
    category: "Thiết bị Điện",
    brand: "Khác",
    image: "https://picsum.photos/seed/36/300/300",
  },
  {
    id: 37,
    name: "Máy biến áp THIBIDI 3 pha",
    category: "Thiết bị Điện",
    brand: "Khác",
    image: "https://picsum.photos/seed/37/300/300",
  },
  {
    id: 38,
    name: "Thang máng cáp sơn tĩnh điện",
    category: "Thiết bị Điện",
    brand: "Khác",
    image: "https://picsum.photos/seed/38/300/300",
  },
  {
    id: 39,
    name: "Hệ thống tiếp địa chống sét",
    category: "Thiết bị Điện",
    brand: "Khác",
    image: "https://picsum.photos/seed/39/300/300",
  },
  {
    id: 40,
    name: "Đèn LED Highbay nhà xưởng",
    category: "Thiết bị Điện",
    brand: "Khác",
    image: "https://picsum.photos/seed/40/300/300",
  },

  // THIẾT BỊ CẤP THOÁT NƯỚC (20 SP)
  {
    id: 41,
    name: "Bơm tăng áp Grundfos Scala2",
    category: "Thiết bị Cấp thoát nước",
    brand: "Grundfos",
    image: "https://picsum.photos/seed/41/300/300",
  },
  {
    id: 42,
    name: "Bơm ly tâm trục đứng Grundfos CR",
    category: "Thiết bị Cấp thoát nước",
    brand: "Grundfos",
    image: "https://picsum.photos/seed/42/300/300",
  },
  {
    id: 43,
    name: "Bơm chìm nước thải Grundfos",
    category: "Thiết bị Cấp thoát nước",
    brand: "Grundfos",
    image: "https://picsum.photos/seed/43/300/300",
  },
  {
    id: 44,
    name: "Bơm nước nóng tuần hoàn Grundfos",
    category: "Thiết bị Cấp thoát nước",
    brand: "Grundfos",
    image: "https://picsum.photos/seed/44/300/300",
  },
  {
    id: 45,
    name: "Cụm bơm tăng áp biến tần Grundfos",
    category: "Thiết bị Cấp thoát nước",
    brand: "Grundfos",
    image: "https://picsum.photos/seed/45/300/300",
  },
  {
    id: 46,
    name: "Bơm cứu hỏa Grundfos trục ngang",
    category: "Thiết bị Cấp thoát nước",
    brand: "Grundfos",
    image: "https://picsum.photos/seed/46/300/300",
  },
  {
    id: 47,
    name: "Bình tích áp Varem 100L",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/47/300/300",
  },
  {
    id: 48,
    name: "Ống nhựa PPR Tiền Phong PN10",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/48/300/300",
  },
  {
    id: 49,
    name: "Phụ kiện ống uPVC Class 2",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/49/300/300",
  },
  {
    id: 50,
    name: "Máy lọc nước công nghiệp RO",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/50/300/300",
  },
  {
    id: 51,
    name: "Đồng hồ đo lưu lượng nước",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/51/300/300",
  },
  {
    id: 52,
    name: "Bồn nước inox Đại Thành 2000L",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/52/300/300",
  },
  {
    id: 53,
    name: "Máy nước nóng năng lượng mặt trời",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/53/300/300",
  },
  {
    id: 54,
    name: "Phao cơ chống tràn Italy",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/54/300/300",
  },
  {
    id: 55,
    name: "Bộ lọc y lọc rác inox 304",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/55/300/300",
  },
  {
    id: 56,
    name: "Ống HDPE thoát nước gân sóng",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/56/300/300",
  },
  {
    id: 57,
    name: "Hố ga nhựa thông minh",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/57/300/300",
  },
  {
    id: 58,
    name: "Vòi sen tắm nhiệt độ TOTO",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/58/300/300",
  },
  {
    id: 59,
    name: "Bệt vệ sinh thông minh Inax",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/59/300/300",
  },
  {
    id: 60,
    name: "Bộ xử lý nước thải sinh hoạt",
    category: "Thiết bị Cấp thoát nước",
    brand: "Khác",
    image: "https://picsum.photos/seed/60/300/300",
  },

  // VAN & PHỤ KIỆN (20 SP)
  {
    id: 61,
    name: "Van bướm điều khiển điện Belimo",
    category: "Van & Phụ kiện",
    brand: "Belimo",
    image: "https://picsum.photos/seed/61/300/300",
  },
  {
    id: 62,
    name: "Van bi 2 ngã Belimo DN50",
    category: "Van & Phụ kiện",
    brand: "Belimo",
    image: "https://picsum.photos/seed/62/300/300",
  },
  {
    id: 63,
    name: "Động cơ điều khiển van gió Belimo",
    category: "Van & Phụ kiện",
    brand: "Belimo",
    image: "https://picsum.photos/seed/63/300/300",
  },
  {
    id: 64,
    name: "Van cân bằng tự động Belimo",
    category: "Van & Phụ kiện",
    brand: "Belimo",
    image: "https://picsum.photos/seed/64/300/300",
  },
  {
    id: 65,
    name: "Cảm biến áp suất đường ống Belimo",
    category: "Van & Phụ kiện",
    brand: "Belimo",
    image: "https://picsum.photos/seed/65/300/300",
  },
  {
    id: 66,
    name: "Van chặn lửa cầu chì",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/66/300/300",
  },
  {
    id: 67,
    name: "Van giảm áp nước Shinyi",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/67/300/300",
  },
  {
    id: 68,
    name: "Van một chiều lá lật inox",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/68/300/300",
  },
  {
    id: 69,
    name: "Van cổng ty chìm tay quay",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/69/300/300",
  },
  {
    id: 70,
    name: "Van an toàn hơi nóng",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/70/300/300",
  },
  {
    id: 71,
    name: "Van điện từ TPC Hàn Quốc",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/71/300/300",
  },
  {
    id: 72,
    name: "Khớp nối mềm cao su mặt bích",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/72/300/300",
  },
  {
    id: 73,
    name: "Đầu phun chữa cháy Sprinkler",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/73/300/300",
  },
  {
    id: 74,
    name: "Trụ cứu hỏa ngoài trời",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/74/300/300",
  },
  {
    id: 75,
    name: "Van xả khí tự động bằng đồng",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/75/300/300",
  },
  {
    id: 76,
    name: "Mặt bích thép JIS 10K",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/76/300/300",
  },
  {
    id: 77,
    name: "Bulong inox 316 chịu lực",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/77/300/300",
  },
  {
    id: 78,
    name: "Co, Tê, Thu bằng thép đúc",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/78/300/300",
  },
  {
    id: 79,
    name: "Van phao thủy lực Shinyi",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/79/300/300",
  },
  {
    id: 80,
    name: "Rọ bơm gang mặt bích",
    category: "Van & Phụ kiện",
    brand: "Khác",
    image: "https://picsum.photos/seed/80/300/300",
  },

  // VẬT TƯ THÔNG GIÓ (20 SP)
  {
    id: 81,
    name: "Ống gió xoắn tôn mạ kẽm",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/81/300/300",
  },
  {
    id: 82,
    name: "Ống gió mềm có cách nhiệt",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/82/300/300",
  },
  {
    id: 83,
    name: "Miệng gió 4 hướng 600x600",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/83/300/300",
  },
  {
    id: 84,
    name: "Hộp box miệng gió tôn",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/84/300/300",
  },
  {
    id: 85,
    name: "Quạt ly tâm hút khói hành lang",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/85/300/300",
  },
  {
    id: 86,
    name: "Quạt hướng trục Kruger",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/86/300/300",
  },
  {
    id: 87,
    name: "Lưới lọc bụi sơ cấp G4",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/87/300/300",
  },
  {
    id: 88,
    name: "Màng lọc HEPA H13 phòng sạch",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/88/300/300",
  },
  {
    id: 89,
    name: "Ống gió vải chống cháy",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/89/300/300",
  },
  {
    id: 90,
    name: "Ke tăng cứng ống gió",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/90/300/300",
  },
  {
    id: 91,
    name: " Silicon dán ống gió chuyên dụng",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/91/300/300",
  },
  {
    id: 92,
    name: "Ty ren mạ kẽm treo ống",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/92/300/300",
  },
  {
    id: 93,
    name: "Cùm treo ống gió các loại",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/93/300/300",
  },
  {
    id: 94,
    name: "Băng keo bạc dán mối nối",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/94/300/300",
  },
  {
    id: 95,
    name: "Chụp thông hơi inox 304",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/95/300/300",
  },
  {
    id: 96,
    name: "Quạt thông gió âm trần gắn ống",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/96/300/300",
  },
  {
    id: 97,
    name: "Tiêu âm ống gió bông thủy tinh",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/97/300/300",
  },
  {
    id: 98,
    name: "Lò xo chống rung treo quạt",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/98/300/300",
  },
  {
    id: 99,
    name: "Sơn mạ kẽm lạnh Zinga",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/99/300/300",
  },
  {
    id: 100,
    name: "Máy đo lưu lượng gió cầm tay",
    category: "Vật tư thông gió",
    brand: "Khác",
    image: "https://picsum.photos/seed/100/300/300",
  },
];

// Danh sách các dự án
export const projectsData = [
  {
    id: 1,
    title: "Lắp đặt điều hoà trung tâm VRV - Tòa nhà văn phòng Geleximco",
    category: "Lắp đặt điều hoà trung tâm",
    region: "TP Hà Nội",
    image: "https://picsum.photos/id/101/500/350",
    description:
      "Hệ thống điều hòa trung tâm công suất lớn cho tòa nhà 20 tầng.",
    year: "2024",
    status: "Đã hoàn thành",
  },
  {
    id: 2,
    title: "Hệ thống thông gió nhà xưởng sản xuất thực phẩm Masan",
    category: "Lắp đặt hệ thống thông gió",
    region: "Nghệ An",
    image: "https://picsum.photos/id/102/500/350",
    description: "Thi công hệ thống hút mùi và cấp khí tươi đạt chuẩn ISO.",
    year: "2023",
    status: "Đã hoàn thành",
  },
  {
    id: 3,
    title: "Lắp đặt hệ thống năng lượng mặt trời 500kWp - Nhà máy dệt",
    category: "Lắp đặt hệ thống năng lượng mặt trời",
    region: "Nam Định",
    image: "https://picsum.photos/id/103/500/350",
    description:
      "Giải pháp điện mặt trời áp mái giúp tiết kiệm 30% chi phí điện năng.",
    year: "2024",
    status: "Đang thực hiện",
  },
  {
    id: 4,
    title: "Hàn cơ khí kết cấu thép kho bãi Logistic",
    category: "Hàn cơ khí",
    region: "Quảng Ninh",
    image: "https://picsum.photos/id/104/500/350",
    description: "Gia công và lắp dựng khung kèo thép khẩu độ lớn.",
    year: "2023",
    status: "Đã hoàn thành",
  },
  {
    id: 5,
    title: "Hệ thống điện nước khu nghỉ dưỡng Vinpearl",
    category: "Lắp đặt hệ thống điện nước",
    region: "Nha Trang",
    image: "https://picsum.photos/id/105/500/350",
    description:
      "Thi công trọn gói hạ tầng điện nước cho 50 căn villa cao cấp.",
    year: "2022",
    status: "Đã hoàn thành",
  },
  // ... (Dưới đây là hàm tạo tiếp 195 dữ liệu tương tự để đảm bảo đủ 200 cái nhanh nhất)
  ...Array.from({ length: 195 }, (_, i) => {
    const categories = [
      "Lắp đặt điều hoà trung tâm",
      "Lắp đặt điều hòa treo tường",
      "Hàn cơ khí",
      "Xây dựng",
      "Lắp đặt hệ thống điện nước",
      "Lắp đặt hệ thống năng lượng mặt trời",
      "Lắp đặt hệ thống thông gió",
    ];
    const regions = [
      "TP Hà Nội",
      "TP HCM",
      "Nha Trang",
      "Nam Định",
      "Lào Cai",
      "Thái Nguyên",
      "Đà Nẵng",
      "Nghệ An",
      "Quảng Ninh",
    ];
    const cat = categories[i % categories.length];
    const reg = regions[i % regions.length];

    return {
      id: i + 6,
      title: `${cat} cho công trình số ${i + 100}`,
      category: cat,
      region: reg,
      image: `https://picsum.photos/id/${(i + 110) % 1000}/500/350`,
      description: `Dự án thực hiện tại ${reg} với quy mô lớn, đảm bảo chất lượng kỹ thuật HABAKO.`,
      year: "2023",
      status: i % 10 === 0 ? "Đang thực hiện" : "Đã hoàn thành",
    };
  }),
];
const titles = [
  "Giải pháp lắp đặt hệ thống Chiller tiết kiệm 30% điện năng",
  "Habako hoàn thành bảo trì định kỳ cho chuỗi khách sạn 5 sao",
  "Tầm quan trọng của việc thay thế lọc gió trong hệ thống HVAC",
  "Quy trình thi công kho lạnh đạt chuẩn ISO 9001",
  "Habako vinh dự nhận giải thưởng nhà thầu uy tín năm 2025",
  "Hướng dẫn vận hành hệ thống VRV cho tòa nhà văn phòng",
  "Công nghệ làm lạnh biến tần Inverter trong công nghiệp",
  "Habako mở rộng chi nhánh mới tại khu vực miền Trung",
];

const categories = [
  "Tin công ty",
  "Kiến thức chuyên ngành",
  "Công nghệ mới",
  "Dự án tiêu biểu",
];

const generateNews = (count) => {
  const news = [];
  for (let i = 1; i <= count; i++) {
    const category = categories[i % categories.length];
    const titleBase = titles[i % titles.length];

    news.push({
      id: i,
      title: `${titleBase} - Bài viết số ${i}`,
      category: category,
      date: `2025-12-${(i % 28) + 1}`,
      image: `https://picsum.photos/seed/news-${i}/400/250`,
      sapo: `Đây là tóm tắt nội dung của bài viết thứ ${i}. Habako cam kết mang đến những kiến thức hữu ích nhất về ngành nhiệt lạnh công nghiệp...`,
      content: `Nội dung chi tiết cho bài báo số ${i}...`,
    });
  }
  return news.reverse(); // Tin mới nhất lên đầu
};

export const newsData = generateNews(300);
